import CallIcon from '@mui/icons-material/Call';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { Box, IconButton, Paper, PaperProps, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useClipboard } from '../hooks/useClipboard';
import { getConfig } from '../utils/config';
import { formatPhoneNumber } from '../utils/format';

const { supportEmail, supportPhone } = getConfig();

const contacts = {
  email: {
    name: supportEmail,
    value: supportEmail,
    link: `mailto:${supportEmail}`,
  },
  tel: {
    name: formatPhoneNumber(supportPhone),
    value: supportPhone,
    link: `tel:${supportPhone}`,
  },
};

export const ContactsSupport = ({ sx, ...rest }: PaperProps) => {
  const { t } = useTranslation();
  const { copyToClipboard } = useClipboard();

  return (
    <Paper sx={{ p: 4, ...sx }} {...rest}>
      <Box>
        <Typography variant={'h6'}>{t('email')}</Typography>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={6}>
          <Typography>{contacts.email.name}</Typography>
          <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={2}>
            <IconButton color={'primary'} component={Link} to={contacts.email.link} target={'_blank'}>
              <ForwardToInboxIcon />
            </IconButton>
            <IconButton color={'primary'} onClick={() => copyToClipboard(contacts.email.value)}>
              <ContentCopyIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Box>
      <Box mt={2}>
        <Typography variant={'h6'}>{t('phone')}</Typography>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={6}>
          <Typography>{contacts.tel.name}</Typography>
          <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={2}>
            <IconButton color={'primary'} component={Link} to={contacts.tel.link} target={'_blank'}>
              <CallIcon />
            </IconButton>
            <IconButton color={'primary'} onClick={() => copyToClipboard(contacts.tel.value)}>
              <ContentCopyIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
};
